import React from 'react'
import Select from 'react-select'
import BaseField from './BaseField'

export const CustomSelectField = ({ input: { value, name, onChange, onBlur }, className, options, ...rest }) => {
	return <BaseField {...rest}>
		<Select
			value={value}
			name={name}
			onChange={(value) => onChange(value)}
         	onBlur={() => {}}
			className={'c-select ' + className}
			classNamePrefix='c-select'
			options={options}
			isSearchable={false}
			{...rest}
		/>
	</BaseField>
}

export default CustomSelectField



// WEBPACK FOOTER //
// ./src/components/form/CustomSelectField.js